/*
 * @Description: 
 * @Date: 2025-09-01 10:22:20
 * @LastEditTime: 2026-06-16 11:52:02
 * @FilePath: \hui_ai_ui\src\config.js
 */
// src/config.js

const branch = process.env.VUE_APP_GIT_BRANCH;
const appEnv = process.env.VUE_APP_ENV;
// 增强环境检测：如果环境变量未定义或为空，默认为development
const environment = (appEnv === 'production') ? 'production' : 'development';
// 检测是否在 Tauri 环境中
export const isTauri = (() => {
  if (typeof window === 'undefined') return false;
  // Tauri v1 和 v2 都支持 __TAURI__
  if ('__TAURI__' in window) {
    return true;
  }
  // 备用检测：检查 Tauri IPC
  if ('__TAURI_IPC__' in window) {
    return true;
  }
  return false;
})();

// 检测是否在 Electron 环境中
// preload 会注入 window.__ELECTRON__，UA 检测作为兜底（开发期 preload 未生效时也能识别）
export const isElectron = (() => {
  if (typeof window === 'undefined') return false;
  if (window.__ELECTRON__ === true) return true;
  if (window.electronBridge) return true;
  return typeof navigator !== 'undefined' && /Electron/i.test(navigator.userAgent);
})();

// 「是否桌面端」语义：路由 hash、Client-channel: pc、API 域名选择都用这个
// 注意：不要用它判断 Tauri 独有能力（如本地 models.json），那种场景继续用 isTauri
export const isDesktop = isTauri || isElectron;

console.log(`[应用信息] 当前环境: ${environment} (打包命令: ${appEnv}, 分支: ${branch}, Tauri: ${isTauri}, Electron: ${isElectron})`);

/**
 * 这是一个动态获取API域名的方法
 */
export function getApiBaseUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const platform = urlParams.get('platform');
    
    // Tauri / Electron 环境优先检测（必须在localhost检测之前）
    if (isDesktop) {
        console.log(`[桌面端环境检测] VUE_APP_ENV: ${appEnv}, environment: ${environment}, electron: ${isElectron}`);
        return environment === 'production' 
            ? 'https://ai.xinfushenghuo.cn/huiaiapi'
            : 'https://aitest.xinfushenghuo.cn/huiaiapi';
    }
    
    // 本地调试时使用代理路径
    if (window.location.hostname === 'localhost') {
        return '/huiaiapi';
    }
    
    // Web 生产环境，固定使用 https 协议
    const apiUrl = `https://${window.location.host}/huiaiapi`;
    // development环境打印API地址
    if (environment === 'development') {
        // console.log(`API地址: ${apiUrl}`);
    }
    return apiUrl;
}

/**
 * 后端 WebSocket 的地址前缀（不含具体路径）
 *
 * 为什么不能直接用 window.location.host：
 * Electron 打包后页面走 app://hui/index.html，location.host 是 "hui"，
 * 拼出来是 wss://hui/huiaiapi/... —— 域名不存在，握手必然失败。
 * 而 dev 跑在 localhost:9887，走的是 localhost 分支，所以只有打包后才复现。
 * 所以桌面端必须写死 API 域名，跟 getApiBaseUrl 的桌面端分支保持一致。
 *
 * @returns {string} 形如 wss://ai.xinfushenghuo.cn/huiaiapi
 */
export function getWsBaseUrl() {
    // 桌面端（Tauri / Electron）：绝不能碰 location.host
    if (isDesktop) {
        return environment === 'production'
            ? 'wss://ai.xinfushenghuo.cn/huiaiapi'
            : 'wss://aitest.xinfushenghuo.cn/huiaiapi';
    }
    // 本地调试（浏览器 localhost）统一走测试环境
    if (window.location.hostname === 'localhost') {
        return 'wss://aitest.xinfushenghuo.cn/huiaiapi';
    }
    // Web 生产环境使用当前域名
    return `wss://${window.location.host}/huiaiapi`;
}

// ▼▼▼ [核心修改点] ▼▼▼
// 为 modelManagementApi 创建一个环境地图用于getUserId
const modelManagementUrls = {
    production: "https://address.xinfushenghuo.cn",      // 正式环境域名
    development: "https://addresstest.xinfushenghuo.cn" // 测试环境域名
};
// 根据当前环境，从上面的对象中选择正确的域名并导出
export const modelManagementApi = modelManagementUrls[environment];
// ▲▲▲ [核心修改点] ▲▲▲

const modelLawUrls = {
    production: `https://${window.location.host}`, // "https://ai.xinfushenghuo.cn", // "https://papi.lawxp.com",      // 正式环境域名
    development: `https://${window.location.host}` // 固定使用 https 协议
    //     development: "https://aitest.xinfushenghuo.cn" // "http://211.144.80.99:5555" //"https://testapi.lawxp.com" // 测试环境域名 https://116.90.87.64/n1/s_ailaw.aspx
};

// 如果在桌面端环境下，使用固定的测试环境地址
export const modelLawApi = isDesktop ? 'https://aitest.xinfushenghuo.cn' : modelLawUrls[environment];

// （可选）我们也可以导出一个默认配置，但主要使用上面的方法
export default {
    branch,
    environment
};

/**
 * 判断是否为移动端设备且屏幕宽度小于768px
 * @returns {boolean} 如果是移动端小屏幕返回true，否则返回false
 */
export function isMobileDevice() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isWeChat = /MicroMessenger/i.test(navigator.userAgent);
    const isSmallScreen = window.innerWidth < 768;
    return (isMobile || isWeChat) && isSmallScreen;
}

/**
 * 根据当前环境获取主页URL
 * 测试环境返回 https://test.likewon.net
 * 正式环境返回 https://www.likewon.net
 * @returns {string} 主页URL
 */
export function getHomeUrl() {
    const homeUrls = {
        production: "https://www.likewon.net",
        development: "https://test.likewon.net"
    };
    return homeUrls[environment];
}

/**
 * 根据当前环境获取批量导入URL
 * 测试环境返回 https://rpaai.xinfushenghuo.cn/dev/ai/column
 * 正式环境返回 https://rpaai.xinfushenghuo.cn/pro/ai/column
 * @returns {string} 批量导入URL
 */
export function getBatchImportUrl() {
    const batchImportUrls = {
        production: "https://rpaai.xinfushenghuo.cn/pro/ai/column",
        development: "https://rpaai.xinfushenghuo.cn/dev/ai/column"
    };
    return batchImportUrls[environment];
}